import SimpleSelect from './simple-select';

class PeopleSelect {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  initialize() {
    this.bindUI();
    this.initCustomSelect();
    this.bindEvents();
  }

  unmount() {
    this.ui.$select.removeEventListener('change', this.onChange.bind(this));
    window.customselect = null;
    this.ui = {};
  }

  initCustomSelect() {
    window.customselect = new SimpleSelect({
      element: document.querySelector('[data-ref="peoples-dropdown"]'),
      container: '.custom-select-wrapper',
    });
  }

  bindUI() {
    this.ui = {};
    this.ui.$select = this.element.querySelector('[data-ref="peoples-dropdown"]');
    this.ui.$peopleItems = [...this.element.querySelectorAll('[data-ref="people-item"]')];
  }

  bindEvents() {
    this.ui.$select.addEventListener('change', this.onChange.bind(this));
    // if (window.matchMedia('(max-width: 1100px)').matches) {
    //   window.addEventListener('scroll', this.onScroll.bind(this));
    // }
  }

  onChange(e) {
    const target = e.currentTarget;
    if (!target.matches('[data-ref="peoples-dropdown"]')) return;

    this.ui.$peopleItems.forEach((people) => {
      people.classList.remove('people--active');
    });


    const index = this.ui.$select.options[this.ui.$select.selectedIndex].getAttribute('data-index');

    this.element.querySelector(`#index-${index}`).classList.add('people--active');
  }

  onresize() {
    this.ui.$peopleItems.forEach((people) => {
      people.classList.remove('people--active');
    });
  }


  // onScroll() {
  //   const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  //   if (scrollTop >= (this.el.offsetTop - 56)) {
  //     this.el.querySelector('.sidebar').classList.add('is-sticky');
  //   }
  //   if (scrollTop > this.el.clientHeight + (this.el.offsetTop - 56) || scrollTop < (this.el.offsetTop - 56)) {
  //     this.el.querySelector('.sidebar').classList.remove('is-sticky');
  //   }
  // }
}

export default PeopleSelect;
